import { useState } from 'react';
import ResponseException from '../models/ResponseException';
import { AxiosPrivate } from '../utils/axios';

export const useDeleteComments = () => {
  const [errors, setErrors] = useState<string[]>([]);
  return {
    deleteComments: async (
      commentsToDelete: string[],
      count: number,
      commentSetId: string,
      deleteEmptyCommentSet = true,
    ) => {
      setErrors([]);
      try {
        const data = { id: commentsToDelete };
        await AxiosPrivate.delete('/comments/batch', { data });
        if (deleteEmptyCommentSet && count < 1) {
          await AxiosPrivate.delete(`/comments/set/${commentSetId}`);
        }
      } catch (e) {
        // TODO: error handling
      }
    },
  };
};
